import { format } from "date-fns";
import { omit } from "lodash";

import { SurveyAnswers } from "@/contexts";
import { RetriageUserProfile } from "@/models";
import { omitCmsAccessPhi } from "@/utils/cmsAccess";

import { convertKgToLb } from "./UnitUtils";
import { DPP_SURVEY_ANSWER_BLOCKLIST } from "./dpp";

// Retriage saves go to the same secure-storage record as initial triage, so
// they drop everything sanitizeDppSurveyAnswers drops
const RETRIAGE_SURVEY_ANSWER_BLOCKLIST = [
  ...DPP_SURVEY_ANSWER_BLOCKLIST,
  "medSignup",
];

export function getSanitizedRetriageAnswers(
  rawSurveyAnswers: SurveyAnswers,
): Record<string, any> {
  const surveyAnswers = omitCmsAccessPhi(rawSurveyAnswers);
  let sanitizedSurveyAnswers: Record<string, any> = omit(
    surveyAnswers,
    RETRIAGE_SURVEY_ANSWER_BLOCKLIST,
  );

  // convert date to string (don't need/want time info)
  if (surveyAnswers.retriageEligibilityCheck?.dob) {
    sanitizedSurveyAnswers = {
      ...sanitizedSurveyAnswers,
      retriageEligibilityCheck: {
        ...surveyAnswers.retriageEligibilityCheck,
        dob: format(
          surveyAnswers.retriageEligibilityCheck.dob as Date,
          "yyyy-MM-dd",
        ),
      },
    };
  }
  return sanitizedSurveyAnswers;
}

export function sanitizeRetriageAnswers(surveyAnswers: SurveyAnswers): string {
  return JSON.stringify(getSanitizedRetriageAnswers(surveyAnswers));
}

export const getWeightInLbs = ({
  weightInKg,
  weightInLb,
}: RetriageUserProfile): number | undefined => {
  if (weightInLb) {
    return weightInLb;
  }
  if (weightInKg) {
    return convertKgToLb({
      mainUnitValue: weightInKg,
    }).mainUnitValue;
  }
  return undefined;
};
